/* Stof meter-invoer — aanpak A.
   Variantprijs = prijs per 10 cm. Shopify-quantity = aantal eenheden van 10 cm.
   meters -> eenheden, live totaal, "Lengte"-eigenschap, en (indien < 1 m)
   een losse Aansnijtoeslag-regel bij het toevoegen aan de winkelwagen. */
(function () {
  var wrap = document.querySelector('[data-stof-meter]');
  if (!wrap) return;

  var input = wrap.querySelector('[data-stof-meter-input]');
  var totalEl = wrap.querySelector('[data-stof-total]');
  var totalGrossEl = wrap.querySelector('[data-stof-total-gross]');
  var feeNote = wrap.querySelector('[data-stof-fee-note]');

  var priceCents = parseInt(wrap.dataset.priceCents, 10) || 0;          // cents per 10 cm
  var kortingPct = parseInt(wrap.dataset.kortingPct, 10) || (window.STOF_KORTING_PCT | 0) || 0;
  var kortingZichtbaar = !document.documentElement.classList.contains('stof-hide-korting');
  var minMeters = parseFloat(wrap.dataset.minMeters) || 0.1;
  var feeCents = parseInt(wrap.dataset.feeCents, 10) || 0;
  var feeThresholdUnits = parseInt(wrap.dataset.feeThresholdUnits, 10) || 10;
  var feeVariantId = wrap.dataset.feeVariantId || '';

  var form = document.querySelector('form[action*="/cart/add"], product-form form');
  var section = wrap.closest('.shopify-section');
  if (section) section.classList.add('stof-has-meter');

  // Dawn koppelt de quantity-input soms via form="" i.p.v. nesting — zoek breed.
  var qtyInput = (form && form.querySelector('[name="quantity"]')) ||
    document.querySelector('.quantity__input[name="quantity"]') ||
    document.querySelector('[name="quantity"]');

  function fmt(cents) {
    var v = (Math.round(cents) / 100).toFixed(2).replace('.', ',');
    return '€ ' + v.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function parseMeters(raw) {
    var n = parseFloat(String(raw).replace(',', '.').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : n;
  }

  // rond af op veelvoud van 0,1 m, naar boven (nooit te weinig factureren)
  function snapUp(m) {
    return Math.ceil(m * 10 - 1e-6) / 10;
  }

  // "1" bij een heel getal, anders "1,7"
  function fmtMeters(m) {
    return (Math.round(m * 10) % 10 === 0) ? String(Math.round(m)) : m.toFixed(1).replace('.', ',');
  }

  function compute(rawValue) {
    var m = parseMeters(rawValue);
    if (m === null || m <= 0) m = minMeters;
    m = snapUp(m);
    if (m < minMeters) m = snapUp(minMeters);
    var units = Math.round(m * 10);
    var lengthText = fmtMeters(m) + ' meter';
    var feeApplies = feeCents > 0 && units < feeThresholdUnits;
    var actievePct = kortingZichtbaar ? kortingPct : 0;
    var fabricGross = units * priceCents;
    var fabricNet = actievePct > 0 ? Math.round(fabricGross * (100 - actievePct) / 100) : fabricGross;
    var feePart = feeApplies ? feeCents : 0; // toeslag valt buiten de zakelijke korting
    var total = fabricNet + feePart;
    var totalGross = fabricGross + feePart;
    return {
      meters: m, units: units, lengthText: lengthText, feeApplies: feeApplies,
      total: total, totalGross: totalGross, discounted: actievePct > 0
    };
  }

  function setProp(name, value) {
    if (!form) return;
    var el = form.querySelector('input[name="properties[' + name + ']"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'properties[' + name + ']';
      form.appendChild(el);
    }
    el.value = value;
  }

  function apply(s) {
    if (totalEl) totalEl.textContent = fmt(s.total);
    if (totalGrossEl) {
      totalGrossEl.hidden = !s.discounted;
      if (s.discounted) totalGrossEl.textContent = fmt(s.totalGross);
    }
    if (feeNote) feeNote.hidden = !s.feeApplies;
    if (qtyInput) {
      qtyInput.value = s.units;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    setProp('Lengte', s.lengthText);
  }

  // tijdens typen: alleen herberekenen, invoerveld niet overschrijven
  input.addEventListener('input', function () {
    apply(compute(input.value));
  });
  // na typen: normaliseren naar "1,7"
  input.addEventListener('change', normalize);
  input.addEventListener('blur', normalize);
  function normalize() {
    var s = compute(input.value);
    input.value = fmtMeters(s.meters);
    apply(s);
  }

  wrap.querySelectorAll('[data-stof-step]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var dir = parseInt(btn.dataset.stofStep, 10) || 1;
      var cur = parseMeters(input.value);
      if (cur === null) cur = minMeters;
      var next = Math.round((cur + dir * 0.1) * 10) / 10;
      if (next < minMeters) next = minMeters;
      input.value = fmtMeters(next);
      normalize();
    });
  });

  // Toevoegen aan winkelwagen: zelf afhandelen zodat lengte + toeslag-regel meegaan.
  // Delegatie op document (capture) zodat het blijft werken nadat Dawn het
  // formulier opnieuw rendert bij een variantwissel.
  function currentVariantId(f) {
    var idEl = f && f.querySelector('[name="id"]');
    if (idEl && idEl.value) return idEl.value;
    var vs = document.querySelector('variant-selects [data-selected-variant]');
    if (vs) { try { var j = JSON.parse(vs.textContent); if (j && j.id) return String(j.id); } catch (e) {} }
    return new URLSearchParams(location.search).get('variant');
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches) return;
    if (!f.matches('form[action*="/cart/add"]') && !f.closest('product-form')) return;
    if (!document.body.contains(input)) return; // meter-widget weg -> niks doen

    var variantId = currentVariantId(f);
    if (!variantId) return; // laat Dawn het afhandelen

    e.preventDefault();
    e.stopImmediatePropagation();

    var s = compute(input.value);
    var items = [{
      id: Number(variantId),
      quantity: s.units,
      properties: { 'Lengte': s.lengthText }
    }];
    if (s.feeApplies && feeVariantId) {
      items.push({ id: Number(feeVariantId), quantity: 1, properties: { '_voor': String(variantId) } });
    }

    var btn = f.querySelector('[type="submit"], [name="add"]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.d && res.d.description) || 'cart error');
        window.location.href = root + 'cart';
      })
      .catch(function (err) {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
        alert('Toevoegen aan winkelwagen is niet gelukt: ' + err.message);
      });
  }, true);

  document.addEventListener('stof:klantmodus', function (e) {
    kortingZichtbaar = !!(e.detail && e.detail.show);
    normalize();
  });

  normalize();
})();
